try {
  const reportToH5Common = (data: Record<string, string>) => {
    const postData = {
      project: "syzs",
      locationUrl: window.location.href,
      mediaUseragent: window.navigator.userAgent,
      ...data
    };

    const postUrl = "https://fbih5report.3g.qq.com/api/report";

    const xhr = new XMLHttpRequest();
    xhr.open("POST", postUrl, true);
    xhr.setRequestHeader("Content-Type", "text/plain");
    xhr.send(JSON.stringify(postData));
  };

  const getCookie = (name: string) => {
    const r = new RegExp(`(?:^|;+|\\s+)${name}=([^;]*)`);
    const m = document.cookie.match(r);
    return !m ? "" : m[1];
  };

  reportToH5Common({
    eventName: "pageView",
    flag1: getCookie("uin"),
    flag2: getCookie("ptui_loginuin"),
    flag3: getCookie("qq_openid"),
    flag4: getCookie("o_cookie"),
    flag5: getCookie("pt2gguin"),
    flag6: getCookie("clientuin")
  });
} catch (error) {
  // do nothing
}
